/**
 * src/components/publico/BotonPrincipal.jsx
 * La acción principal de una pantalla pública. Una sola por pantalla.
 */
export function BotonPrincipal({ children, cargando, textoCargando, ...resto }) {
  return (
    <button
      {...resto}
      disabled={cargando || resto.disabled}
      style={{
        width: '100%', border: 'none', borderRadius: 'var(--radius-md)',
        padding: 'var(--space-4)', minHeight: '52px',
        fontFamily: 'var(--font-brand)', fontSize: '16px', fontWeight: 600,
        color: '#fff',
        background: cargando ? 'var(--color-accent-2)' : 'var(--gradient-coral)',
        boxShadow: cargando ? 'none' : 'var(--shadow-coral)',
        cursor: cargando ? 'wait' : 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '9px',
        transition: 'transform 0.12s ease, box-shadow 0.2s ease',
      }}
      onMouseDown={e => { if (!cargando) e.currentTarget.style.transform = 'scale(0.985)' }}
      onMouseUp={e => { e.currentTarget.style.transform = 'scale(1)' }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)' }}
    >
      {cargando
        ? <>
            <span style={{
              width: '15px', height: '15px', border: '2px solid currentColor',
              borderTopColor: 'transparent', borderRadius: '50%',
              display: 'inline-block', animation: 'spin 0.7s linear infinite',
            }} />
            {textoCargando || 'Un momento…'}
          </>
        : children}
    </button>
  )
}
